<template>
  <div id="app">
    <!--    <div id="nav">
          <router-link to="/">Home</router-link> |
          <router-link to="/about">About</router-link>
        </div>-->
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'appTem',
    mounted() {

      // 友盟统计添加
      const script = document.createElement("script");
      script.src =
          "https://s95.cnzz.com/z_stat.php?id=1277875016&web_id=1277875016";
      script.language = "JavaScript";
      document.body.appendChild(script);

    },
    watch: {
      $route() {
        if (window._czc) {
          let location = window.location;
          let contentUrl = location.pathname + location.hash;
          let refererUrl = "/";
          window._czc.push(["_trackPageview", contentUrl, refererUrl]);

        }
      }
    }
  }
</script>
<style lang="less">
  html, body {
    background-color: #eb6559;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #595959;
  }
  .demo-dialog{
    .van-dialog__header{
      padding-top: 16px;
      padding-bottom: 16px;
      position: relative;
      &:after{
        position: absolute;
        content: " ";
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 1px solid #EBEBEB;
      }
    }
  }
</style>
